"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const R = __importStar(require("ramda"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_apollo_1 = require("react-apollo");
const table_schema_provider_1 = require("@8base-react/table-schema-provider");
const permissions_provider_1 = require("@8base-react/permissions-provider");
const utils_1 = require("@8base/utils");
/**
 * Component for fetching the table content
 *
 * @prop {string} tableId - Id of the table
 * @prop {(recordsListResult: object) => React.ReactNode} children - Render prop with result of the query
 */
class RecordsList extends react_1.Component {
    constructor() {
        super(...arguments);
        this.isFetchingNewTable = false;
        /** this dirty hack needs to avoid passing the old table data after changing the table */
        this.getRecordsListData = (recordsListResult) => {
            let recordsListData = [];
            if (this.isFetchingNewTable && recordsListResult.loading) {
                recordsListData = [];
            }
            else {
                recordsListData =
                    R.path(['data', 'tableContent'], recordsListResult) ||
                        R.path(['data', 'appContent', 'tableContent'], recordsListResult) ||
                        [];
            }
            if (this.isFetchingNewTable && !recordsListResult.loading) {
                this.stopFetchingNewTable();
            }
            return recordsListData;
        };
        this.renderQuery = ({ tableSchema, loading }) => {
            const _a = this.props, { children, deep, relationItemsCount, filterFields } = _a, rest = __rest(_a, ["children", "deep", "relationItemsCount", "filterFields"]);
            if (!tableSchema && !loading) {
                throw new utils_1.SDKError(utils_1.ERROR_CODES.TABLE_NOT_FOUND, utils_1.PACKAGES.CRUD, `Table doesn't find`);
            }
            if (!tableSchema) {
                return null;
            }
            const query = graphql_tag_1.default(utils_1.createTableFilterGraphqlTag([tableSchema], tableSchema.id, {
                deep,
                relationItemsCount,
                tableContentName: 'tableContent',
                appContentName: 'appContent',
                permissions: this.context.permissions,
                filterFields,
            }));
            return (react_1.default.createElement(react_apollo_1.Query, Object.assign({}, rest, { query: query }), (recordsListResult) => children(Object.assign(Object.assign({}, recordsListResult), { data: this.getRecordsListData(recordsListResult) }))));
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.tableId !== prevProps.tableId) {
            this.startFetchingNewTable();
        }
    }
    startFetchingNewTable() {
        this.isFetchingNewTable = true;
    }
    stopFetchingNewTable() {
        this.isFetchingNewTable = false;
    }
    render() {
        const { tableId } = this.props;
        return react_1.default.createElement(table_schema_provider_1.TableConsumer, { id: tableId }, this.renderQuery);
    }
}
exports.RecordsList = RecordsList;
RecordsList.contextType = permissions_provider_1.PermissionsContext;
//# sourceMappingURL=RecordsList.js.map